module.exports = "<main class=\"gw-main-wrapper\">\n    <div class=\"gw-main\">\n        <div shown-when-loading class=\"gw-load-container\" id=\"loadingMsg\">\n            <p class=\"gw-loading-message\">\n                <span class=\"gw-image-versioning-loading\"></span>\n                <span hidden-when-loading>\n                                {{'portal.index.Loading\\' application'|translate}}\n                            </span>\n            </p>\n        </div>\n    </div>\n</main>"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/platform/segmentation/demolandingpage/views/loadinglandingpage.html
// module id = 944
// module chunks = 0